<template>
  <div class="calico-document-section">
    <input
      ref="documentSectionfileInput"
      type="file"
      hidden
      @change.prevent="onBrowse"
    >

    <div class="section-header">
      <div class="heading">
        <label class="label--large">
          {{ title }}
        </label>
        <span
          v-if="editable"
          style="width: fit-content;"
        >
          <button
            class="button-utility button-utility--small"
            @click.prevent="$refs.documentSectionfileInput.click()"
          >
            <i class="bi bi-plus-lg" /> Add
          </button>
        </span>
      </div>

      <p class="body--xsmall">
        {{ description }}
      </p>
    </div>

    <CalicoDocumentUploadInline
      v-if="draftDocument"
      :document="draftDocument"
      @save="$emit('save', $event)"
      @cancel="$emit('cancel', $event)"
    />

    <CalicoDocumentItem
      v-for="(document, index) in documents"
      :key="document.id || index"
      :document="document"
      :editable="editable"
      @edit="$emit('edit', document)"
      @download="$emit('download', document)"
      @delete="$emit('delete', document)"
      @save="$emit('save', $event)"
      @cancel="$emit('cancel', $event)"
    />

    <label
      v-if="!draftDocument && !documents.length"
      class="label--medium no-documents"
    >
      <i>No documents</i>
    </label>
  </div>
</template>

<script>
import CalicoDocumentItem from '@/components/pattern/documentItem/index.vue'
import CalicoDocumentUploadInline from '@/components/calico/documentUploadInline/index.vue'

export default {
  name: 'CalicoDocumentSection',
  components: {
    CalicoDocumentItem,
    CalicoDocumentUploadInline,
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    documents: {
      type: Array,
      default: () => []
    },
    draftDocument: {
      type: Object,
      default: null
    },
  },
  emits: ['browse', 'edit', 'download', 'delete', 'save', 'cancel'],
  methods: {
    onBrowse (e) {
      const file = e.target.files?.[0] || null
      this.$emit('browse', file)
      this.$refs.documentSectionfileInput.value = ''
    }
  }
}
</script>

<style lang="scss">
.calico-document-section {
  @include stack-space($space-medium);
  @include inset-space($space-medium);
  background: $color-background-primary;

  .section-header {
    @include stack-space($space-small);
    padding-bottom: $space-medium;
    border-bottom: 1px solid $color-border-primary;
    width: 100%;

    .heading {
      @include inline-space($space-none);
      width: 100%;

      label {
        flex: 1;
      }
    }
  }

  .no-documents {
    color: $color-text-secondary;
  }
}
</style>